import { render, staticRenderFns } from "./DatosPantalla.vue?vue&type=template&id=4e049a79&"
import script from "./DatosPantalla.vue?vue&type=script&lang=ts&"
export * from "./DatosPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports